import { render, staticRenderFns } from "./InsectRanking.vue?vue&type=template&id=2c10faeb&scoped=true&"
import script from "./InsectRanking.vue?vue&type=script&lang=js&"
export * from "./InsectRanking.vue?vue&type=script&lang=js&"
import style0 from "./InsectRanking.vue?vue&type=style&index=0&id=2c10faeb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c10faeb",
  null
  
)

/* custom blocks */
import block0 from "./InsectRanking.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c10faeb')) {
      api.createRecord('2c10faeb', component.options)
    } else {
      api.reload('2c10faeb', component.options)
    }
    module.hot.accept("./InsectRanking.vue?vue&type=template&id=2c10faeb&scoped=true&", function () {
      api.rerender('2c10faeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/StationPlaceFloorPlans/InsectRanking.vue"
export default component.exports